<template>
  <div class="header">
    <!-- <a-icon type="logout" /> -->
    <!-- <a-button type="primary" shape="circle" icon="logout"></a-button> -->
    
     <a-popconfirm
    title="确定要退出嘛？"
    ok-text="Yes"
    placement="bottomLeft"
    cancel-text="No"
    @confirm="logout"
  >
     <a-button type="primary" icon="logout" >退出</a-button>
  </a-popconfirm>
    <!-- <notice-icon-view /> -->
    <!-- <a-dropdown>
      <a-icon type="global" />
      <a-menu
        slot="overlay"
        @click="localeChange"
        :selectedKeys="[$route.query.locale || 'zhCN']"
      >
        <a-menu-item key="zhCN">
          中文
        </a-menu-item>
        <a-menu-item key="enUS">
          English
        </a-menu-item>
      </a-menu>
    </a-dropdown> -->
  </div>
</template>

<script>
import NoticeIconView from "@/components/GlobalHeader/NoticeIconView";
import {setAuthority} from "../utils/auth"
export default {
  components: { NoticeIconView },
  methods: {
    localeChange({ key }) {
      this.$router.push({ query: { ...this.$route.query, locale: key } });
      this.$i18n.locale = key;
    },
    logout(){
      console.log("退出");
      setAuthority('guest');
      this.$router.push({path: '/user/login'})
    }
  }
};
</script>

<style scoped>
.header {
  float: right;
  margin-right: 30px;
}
</style>
